// 51元
export const URL1 = 'https://pc.1688.com/product/detail.htm?productCode=cCqTDrUd6kXuDRRmf2VKywuDv%2FlTmhqCtP2w7HTnF5M%3D&productType=GROUP&mkey=k_12026081';
// 正常链接
export const URL2 = 'https://pc.1688.com/product/detail.htm?productCode=hHNTQ3ixn1E0DFbBBph1kB%2F4O4BvVK2T7NbMVHyB2ds%3D&productType=GROUP';
// 问卷调查
export const URL3 = 'https://survey.1688.com/apps/zhiliao/QmpFPKnuc';
// 已废弃的
export const URL4 = 'https://pc.1688.com/product/sod/confirm/sodcombinesell.htm?spm=a2619h.21470821a2619h.kk7uzq1b.1.763c3de7sommrh&comboproductcode=12088182&mkey=k_12026981';
// PC端订购链接 旺信通-接单响应雷达
export const URL5 = 'https://pc.1688.com/product/detail.htm?spm=a26370.20994425.fwsj_work_bench.1.68747ba6Ysx4HB&productCode=csOBJ0jka%2F3dzzbC4Pv1el73pUgmYQvwvfOB452XP%2B4%3D&productType=GROUP'
// 入端版订购链接 询盘提醒_兴业宝旺信通
export const URL6 = 'https://pc.1688.com/product/detail.htm?spm=a26370.20994425.fwsj_work_bench.4.68747ba6Ysx4HB&productCode=WoUggO99bdIQoPGOcYdmbW5dKAzotJfamh82Jpre1r0%3D&productType=GROUP'
// 22元季度优惠券链接：季度优惠券：
export const URL7 = 'https://app.1688.com/3b2a2e82.html?activityCode=018112a934c54562a4264b4d6eec4ca7'
// 68元一年优惠券链接：年度优惠券：
export const URL8 = 'https://app.1688.com/3b2a2e82.html?activityCode=018112a4cb614c7fa695da1b47cfbfe6'
// 提升老客复购率工具链接：优惠券页面：
export const URL9 = 'https://pc.1688.com/product/detail.htm?spm=a26370.20994425.fwsj_work_bench.57.68747ba6fhvU1D&productCode=RU%2B6ygrR9Jq40KLSnVB1qRpVwIe0dbFY03fpluEepZE%3D&productType=GROUP'

// 优选工作台版本台跳转链接：
export const URL10 = 'https://pc.1688.com/product/detail.htm?productCode=6RDXKZoYnXevogt91O5c%2F%2BU5j2VG4xmzldQkMNBM3ZQ%3D&productType=GROUP'

// 商机助理和千牛版跳转：
export const URL11 = 'https://pc.1688.com/product/detail.htm?productCode=BFKgEiEyIPg0O%2BJ9rIw4dAytvPf0RzRC2KQ%2BBJ4Vzv8%3D&productType=GROUP'





function Redirect(to,from){
    if(to.name == 'Questionnaire' ){
        window.location.href= URL3;
        return true;
    }else if(to.name == 'Renew'){
        window.location.href= URL1;
        return true;
    }else if(to.name == 'Welfare'){
        window.location.href= URL1;
        return true;
    }else if(to.name == 'WelfareClassPay'){
        if(to.query.jump_link == 1){
            window.location.href = URL1
            return true;
        }
        if(to.query.jump_link == 2){
            window.location.href = URL2
            return true;
        }
    }else if(to.name == 'Subsidy'){
        window.location.href = URL4;
        return true;
    }else if(to.name == 'WelfareFebruary'){
        window.location.href = URL5;
        return true;
    }else if(to.name == 'WelfareFebruary/MarkPage'){
        window.location.href = URL1;
        return true;
    }else if(to.name == 'WelfareFebruary/Warning'){
        window.location.href = URL5;
        return true;
    }else if(to.name == 'WelfareFebruary/AdditionalGive'){
        window.location.href = URL1;
        return true;
    }else if(to.name == 'WelfareFebruary/Questionnaire'){
        if(to.query.jump_link == 1){
            window.location.href = URL3
            return true;
        }
        if(to.query.jump_link == 2){
            window.location.href = URL1
            return true;
        }
    }else if(to.name == 'TimeOut'){
        window.location.href = URL5;
        return true;
    }else if(to.name == 'MessageSwitch'){
        window.location.href = URL5;
        return true;
    }else if(to.name == 'CustomerInfo'){
        if( to.query.jump_link == 1){
            window.location.href = URL5;
            return true;
        }
    }else if(to.name == 'SuccessfulTrade'){
        window.location.href = URL5;
        return true;
    }else if(to.name == 'WarningTips'){
        window.location.href = URL5;
        return true;    
    }else if(to.name == 'YesterdayBriefing'){
        window.location.href = URL5;
        return true;    
    }else if(to.name == 'YesterdayDetail'){
        window.location.href = URL5;
        return true;
    }


}
export default Redirect;